var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"App"}},[_c('a-layout',{staticClass:"layout",attrs:{"id":"components-layout-demo-top"}},[_c('LayoutHeader'),_c('LayoutContent'),_c('LayoutFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }